// extracted by mini-css-extract-plugin
export default {"button":"add-column_button__JXOGb"};